import { getSelectedFilters } from './actions';

// Hide the recommendation list when filters are selected or when on page > 1 on mobile
export default (selected_filtering = null) => {
  let show_recommendations = true;
  const from_search = document.body.classList.contains('has-overlay-search');

  if (from_search) {
    return;
  }

  if (selected_filtering === null) {
    selected_filtering = getSelectedFilters();
  };

  if (selected_filtering.length > 0) {
    show_recommendations = false;
  }

  if (window.theme.collections.sorting !== 'manual') {
    show_recommendations = false;
  }

  const is_mobile = $('.main-nav--mobile').is(':visible');
  if (is_mobile && window.theme.collections.page > 1) {
    show_recommendations = false;
  }

  console.log('show_recommendations', show_recommendations);
  show_recommendations ? document.querySelector('[data-collection-grid-container] .recommended-products')?.classList.remove('hide') : document.querySelector('[data-collection-grid-container] .recommended-products')?.classList.add('hide');
};
